// import $ from jQuery;

const initDisclaimers = () => {
	if (window.disclaimerSettings && window.disclaimerSettings.length > 0) {
		const targetNode = document.getElementById('eight29-filters');
		const observer = new MutationObserver((mutationList) => {
			for (const mutation of mutationList) {
				if (
					mutation.type === 'childList' &&
					mutation.target.id === 'eight29-filtered-items' &&
					mutation.addedNodes.length > 0 &&
					mutation.addedNodes[0].className === 'no-results'
				) {
					window.disclaimerSettings.forEach((item) => {
						if (
							jQuery(
								`#filter-pills > button > span:contains("${item.pill_text}")`
							).length > 0
						) {
							// console.log( item, `#filter-pills > button > span:contains("${item.pill_text}")` );
							jQuery(
								'#eight29-filtered-items .no-results-text > p:last-child'
							).before(
								`<p class="disclaimer">${item.disclaimer}</p>`
							);
						}
					});
				}
				jQuery('#eight29-filtered-items p.disclaimer').fadeIn(500);
			}
		});
		const config = { attributes: true, childList: true, subtree: true };
		observer.observe(targetNode, config);
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initDisclaimers();

		window.onbeforeprint = null;
		window.onafterprint = null;
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
